import WithGASetup from '../../components/WithGASetup';
import ForgotPassword from './ForgotPassword.js';

export default WithGASetup(ForgotPassword);
